import SearchResults from './SearchResults';

export default function SearchQuestionList() {
  return <SearchResults categoryId={2} />;
}
